export const selectDeployementsLists = (state) => state.deployements.deployementsListsData;
export const selectDeployementsListsStatus = (state) => state.deployements.status;